import React from 'react'

function NewMessageSound() {
  return <></>
}

export default NewMessageSound
